const adminKey = 'degenerateBakerAdminPassword'

export default {
  methods: {
    login(password) {
      this.$cookies.set(adminKey, password)
    },
    logout() {
      this.$cookies.remove(adminKey)
      this.$router.push({ name: 'gallery' })
    },
    prompt() {
      var password = prompt('Admin Password')
      if (password === null) {
        this.logout()
        return false
      } else {
        this.login(password)
        this.authorize()
      }
    },
    authorize() {
      var password = this.$cookies.get(adminKey)
      this.$database
        .collection('passwords')
        .doc('admin')
        .get()
        .then(doc => {
          if (password === doc.data().password) {
            return true
          } else {
            this.prompt()
          }
        })
    }
  }
}
